
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import disclaimerQuery from '~/apollo/queries/disclaimer/disclaimer.gql';

export default {
  name: "HappyKidsInsurerDetail",
  mixins: [eventTrackingMixins],
  props: {
    insurer: {
      type: Object,
      default: () => ({}),
    },
  },
  apollo: {
    disclaimers: {
      query: disclaimerQuery,
      prefetch: true,
      variables() {
        return {
          disclaimer_type: "happy-kids-products-disclaimer",
          locale: this.$normalizeLocale(this.$i18n.locale),
        };
      },
      update(data) {
        return this.$normalizeStrapi(data.blogDisclaimers.data);
      },
    },
  },
  methods: {
    /**
     * @return {string[]}
     * @description set section style based on data from CMS.
     */
     sectionStyle(layoutStyle) {
      if ( !layoutStyle ) return;

      const style = []
      if (layoutStyle?.DisableMinHeight) {
          style.push({'min-height': 'auto'})
      }
      if (layoutStyle?.PaddingTopInPx && layoutStyle?.PaddingTopInPx >= 0 ) {
          style.push({'padding-top': `${layoutStyle?.PaddingTopInPx}px`})
      }
      if (layoutStyle?.PaddingBottomInPx && layoutStyle?.PaddingBottomInPx >= 0 ) {
          style.push({'padding-bottom': `${layoutStyle?.PaddingBottomInPx}px`})
      }
      return style
    },
  },
}
